module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_5010.30da1e4f.png";